import {
  UPDATE_KJS,
  UPDATE_KJS_START,
  UPDATE_KJS_ERROR,
  GET_KJS_LIST_START,
  GET_KJS_LIST,
  GET_KJS_LIST_ERROR,
  GET_KJS_LIST_BY_INSTITUTION_TYPE,
  GET_KJS_LIST_BY_INSTITUTION_TYPE_START,
  GET_KJS_LIST_BY_INSTITUTION_TYPE_ERROR,
  GET_KJS_LIST_BY_MUNICIPALITY,
  GET_KJS_LIST_BY_MUNICIPALITY_START,
  GET_KJS_LIST_BY_MUNICIPALITY_ERROR,
  GET_KJS_LIST_PAGEBALE,
  GET_KJS_LIST_PAGEBALE_START,
  GET_KJS_LIST_PAGEBALE_ERROR,
  GET_KJS_FILTER_LIST,
  GET_KJS_FILTER_LIST_START,
  GET_KJS_FILTER_LIST_ERROR,
  CLEAR_KJS_LIST,
} from '../actions/types';

const initialState = {
  kjsList: [],
  kjs: {},
  loading: false,
  error: undefined,
  totalElements: '',
  syncSignal: false,
};

const clearList = (state) => {
  return {
    ...state,
    kjsList: [],
  };
};

const findAllKjs = (state, action) => {
  return {
    ...state,
    loading: false,
    kjsList: action.payload,
    error: undefined,
  };
};

const findAllKjsStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const findAllKjsError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findAllKjsPageableStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const findAllKjsPageable = (state, action) => {
  return {
    ...state,
    loading: false,
    numberOfPages: action.payload[1],
    totalElements: action.payload[2],
    kjsList: action.payload[0],
  };
};

const findAllKjsPageableError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findAllKjsByInstitutionType = (state, action) => {
  return {
    ...state,
    loading: false,
    kjsList: action.payload,
    error: undefined,
  };
};

const findAllKjsByInstitutionTypeStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const findAllKjsByInstitutionTypeError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findAllKjsByMunicipality = (state, action) => {
  return {
    ...state,
    loading: false,
    kjsList: action.payload,
    error: undefined,
  };
};

const findAllKjsByMunicipalityStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const findAllKjsByMunicipalityError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const updateKjs = (state, action) => {
  return {
    ...state,
    kjsList: state.kjsList.map((kjs) =>
      kjs.id === action.payload.id ? action.payload : kjs
    ),
    kjs: action.payload,
    loading: false,
  };
};

const updateKjsStart = (state) => {
  return {
    ...state,
    error: undefined,
    loading: true,
  };
};

const updateKjsError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_KJS_LIST:
      return findAllKjs(state, action);
    case GET_KJS_LIST_START:
      return findAllKjsStart(state, action);
    case GET_KJS_LIST_ERROR:
      return findAllKjsError(state, action);

    case GET_KJS_LIST_BY_INSTITUTION_TYPE:
      return findAllKjsByInstitutionType(state, action);
    case GET_KJS_LIST_BY_INSTITUTION_TYPE_START:
      return findAllKjsByInstitutionTypeStart(state, action);
    case GET_KJS_LIST_BY_INSTITUTION_TYPE_ERROR:
      return findAllKjsByInstitutionTypeError(state, action);
    case GET_KJS_LIST_BY_MUNICIPALITY:
      return findAllKjsByMunicipality(state, action);
    case GET_KJS_LIST_BY_MUNICIPALITY_START:
      return findAllKjsByMunicipalityStart(state, action);
    case GET_KJS_LIST_BY_MUNICIPALITY_ERROR:
      return findAllKjsByMunicipalityError(state, action);

    case GET_KJS_LIST_PAGEBALE:
    case GET_KJS_FILTER_LIST:
      return findAllKjsPageable(state, action);
    case GET_KJS_LIST_PAGEBALE_START:
    case GET_KJS_FILTER_LIST_START:
      return findAllKjsPageableStart(state);
    case GET_KJS_LIST_PAGEBALE_ERROR:
    case GET_KJS_FILTER_LIST_ERROR:
      return findAllKjsPageableError(state, action);

    case UPDATE_KJS:
      return updateKjs(state, action);
    case UPDATE_KJS_START:
      return updateKjsStart(state);
    case UPDATE_KJS_ERROR:
      return updateKjsError(state, action);

    case CLEAR_KJS_LIST:
      return clearList(state);

    default:
      return state;
  }
}
